import { dcpcApi } from './dcpcApi';
import axios from "axios";
import {hostWithPrefix} from "../../Features/Constructor/common/ApiCommon";

const BAD_MESSAGES_TAG = 'BAD_MESSAGES_TAG';
const DATASOURCE_INCOMING_MESSAGES_TAG = 'DATASOURCE_INCOMING_MESSAGES_TAG';
const INCOMING_MESSAGES_TAG = 'INCOMING_MESSAGES_TAG';
const INCOMING_MESSAGES_TAG_BY_ID = 'INCOMING_MESSAGES_TAG_BY_ID';

dcpcApi.enhanceEndpoints({
  addTagTypes: [
    BAD_MESSAGES_TAG, INCOMING_MESSAGES_TAG, INCOMING_MESSAGES_TAG_BY_ID, DATASOURCE_INCOMING_MESSAGES_TAG,
  ],
});
const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getBadMessages: builder.query({
      query: (params) => ({
        url: 'messages/bad',
        params,
      }),
      providesTags: [BAD_MESSAGES_TAG],
    }),

    confirmBadMessages: builder.mutation({
      query: (checkedMessages) => ({
        url: `message/process/${checkedMessages}`,
        method: 'GET',
      }),
      invalidatesTags: [BAD_MESSAGES_TAG],
    }),

    getMessageFile: builder.query({
      query: (messageId) => ({
        url: `message/file/${messageId}`,
        headers: {
          Accept: 'application/xml',
        },
        // Проверка находится в dcpcApi/dcpcFetchBase, если true использует fetch().text(), а не fetchBaseQuery
        useXmlFetcher: true,
      }),
    }),

    getMessageAttachments: builder.query({
      query: (messageId) => ({
        url: `messages/${messageId}/attachments`,
      }),
    }),

    getIncomingMessageAttachments: builder.query({
      query: (messageId) => ({
        url: `messages-incoming/${messageId}/attachments`,
      }),
    }),

    getMessageAttachmentFile: builder.query({
      query: ({ messageId, attachmentId }) => ({
        url: `messages/${messageId}/attachments/${attachmentId}/data`,
      }),
    }),

    getMessageHeaders: builder.query({
      query: (messageId) => ({
        url: `messages/${messageId}/headers`,
      }),
    }),

    getIncomingMessageHeaders: builder.query({
      query: (messageId) => ({
        url: `message-incoming/${messageId}/headers`,
      }),
    }),

    getMessageIncomingWithDatasource: builder.query({
      query: (searchParams) => ({
        url: 'message-incoming/datasource',
        method: 'GET',
        params: {
          ...searchParams,
        },
      }),
      providesTags: [DATASOURCE_INCOMING_MESSAGES_TAG],
    }),
    getMessageIncoming: builder.query({
      query: (searchParams) => ({
        url: 'message-incoming',
        method: 'GET',
        params: {
          ...searchParams,
        },
      }),
      providesTags: [INCOMING_MESSAGES_TAG],
    }),
    getMessageIncomingById: builder.query({
      query: (id) => ({
        url: `message-incoming/${id}`,
        method: 'GET',
      }),
      providesTags: [INCOMING_MESSAGES_TAG_BY_ID],
    }),

    repeatMessageIncomingProcess: builder.mutation({
      query: (messageId) => ({
        url: `message-incoming/${messageId}/process`,
        method: 'POST',
      }),
      invalidatesTags: [INCOMING_MESSAGES_TAG, INCOMING_MESSAGES_TAG_BY_ID, DATASOURCE_INCOMING_MESSAGES_TAG],
      extraOptions: {
        noToaster: true,
      },
    }),

    getMessages: builder.query({
      query: (searchParams) => ({
        url: 'messages',
        method: 'GET',
        params: {
          ...searchParams,
        },
      }),
    }),

    getMessageById: builder.query({
      query: (id) => ({
        url: `messages/${id}`,
        method: 'GET',
      }),
    }),

    getOutgoingMessages: builder.query({
      query: (params) => ({
        url: 'outgoing-messages',
        method: 'GET',
        params,
      }),
    }),

    getOutgoingMessagesCut: builder.query({
      query: (params) => ({
        url: 'outgoing-messages/cut',
        params,
      }),
    }),

    getOutgoingMessageById: builder.query({
      query: (id) => ({
        url: `outgoing-messages/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export function getMessagesByIds(ids) {
  return axios({
    url: 'http://' + hostWithPrefix + '/allMessages/' + ids,
    method: 'GET',
    responseType: 'arraybuffer'
  });
}

export const {
  useLazyGetBadMessagesQuery,
  useConfirmBadMessagesMutation,
  useGetMessageFileQuery,
  useGetMessageAttachmentsQuery,
  useGetIncomingMessageAttachmentsQuery,
  useLazyGetMessageAttachmentFileQuery,
  useGetMessageHeadersQuery,
  useGetIncomingMessageHeadersQuery,
  useGetMessageIncomingByIdQuery,
  useRepeatMessageIncomingProcessMutation,
  useGetMessageByIdQuery,
  useLazyGetMessageIncomingWithDatasourceQuery,
  useLazyGetMessageIncomingQuery,
  useGetMessagesQuery,
  useLazyGetMessagesQuery,
  useLazyGetOutgoingMessagesQuery,
  useGetOutgoingMessageByIdQuery,
  useLazyGetOutgoingMessagesCutQuery,
} = api;
